<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Hearts</span></p>
<p class="bk-title1"><span>Of Surgeons and Transplants, Miracles and Disasters Along the Cardiac Frontier</span></p>
<p class="authorname"><span>Thomas Thompson</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?044fa2b2